export const colors = {
  transparent: 'transparent',
  black_100: '#25282b',
  black_80: '#52575c',
  black_70: '#727578',
  black_60: '#52575c',
  black_40: '#cacccf',
  black_20: '#dbdde0',
  black_10: '#ededed',
  black_5: '#f9f9fa',
  black: '#a0a4a8',
  gun_metal_100: '#383643',
  white: '#ffffff',
  primary_dark: '#006cdb',
  primary: '#007eff',
  primary_90: '#1a8bff',
  primary_80: '#3398ff',
  primary_70: '#4da5ff',
  primary_60: '#66b2ff',
  primary_50: '#80bfff',
  primary_40: '#99cbff',
  primary_30: '#b3d8ff',
  primary_20: '#cce5ff',
  primary_10: '#e5f2ff',
  primary_5: '#f5faff',
  secondary: '#225FAF',
  secondary_20: '#96AECE',
  secondary_30: '#7BA4D9',
  positive_default: '#2ac769',
  positive_dark: '#159348',
  positive_light: '#40dd7f',
  green_90: '#10773A',
  green_10: '#EEFFF5',
  positive_light_0: '#dff7e8',
  negative_default: '#fb4e4e',
  negative_dark: '#c10606',
  negative_light: '#ff6262',
  negative_20: '#fedcdc',
  negative_10: '#FFEDED',
  warning_dark: '#f6a609',
  warning_default: '#ffbc1f',
  warning_light: '#ffcb52',
  warning_20: '#fff5dd',
  warning_10: '#FFF8E8',
  negative_dark_0: '#bc3d3b',
  negative_dark_1: '#fb4b4b',
  purple: '#42307D',
  purple_25: '#FCFAFF',
  purple_50: '#a80092',
  purple_75: '#cc00b1',
  purple_100: '#F4EBFF',
  purple_800: '#53389E',
  purple_900: '#42307D',
  dark: '#000',
  ag_primary: '#F2703D',
  ag_primary_dark: '#E05F2C',
  airbnb_primary: '#FF5A5F',
  airbnb_primary_dark: '#E05F2C',
};
